import { Component } from "react";
import { Toaster } from "sonner";
import SmoothScroll from "./components/SmoothScroll";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Welcome from "./components/Welcome";
import Courses from "./components/Courses";
import WhyUs from "./components/WhyUs";
import Process from "./components/Process";
import StudentWork from "./components/StudentWork";
import About from "./components/About";
import AdmissionCTA from "./components/AdmissionCTA";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-obsidian text-white px-6 text-center">
          <div>
            <h1 className="font-display text-2xl font-bold">Something went wrong</h1>
            <p className="mt-3 text-gray-400 text-sm">Please refresh the page to continue.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default function App() {
  return (
    <ErrorBoundary>
      <SmoothScroll>
        <div className="relative min-h-screen bg-obsidian text-white">
          <div className="grain-overlay" aria-hidden="true" />
          <Navbar />
          <main>
            <Hero />
            <Marquee />
            <Welcome />
            <Courses />
            <WhyUs />
            <Process />
            <StudentWork />
            <About />
            <AdmissionCTA />
            <Contact />
          </main>
          <Footer />
          <WhatsAppFloat />
          <Toaster
            position="top-center"
            theme="dark"
            richColors
            toastOptions={{
              style: {
                background: "#12141D",
                border: "1px solid rgba(255,255,255,0.1)",
                color: "#fff",
              },
            }}
          />
        </div>
      </SmoothScroll>
    </ErrorBoundary>
  );
}
